// // import React, { useState, useEffect } from "react";
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   Button,
// //   Grid,
// //   MenuItem,
// //   Avatar,
// //   Box,
// //   Typography,
// //   Chip,
// //   IconButton,
// //   FormControlLabel,
// //   Checkbox,
// // } from "@mui/material";
// // import { Edit as EditIcon, Close as CloseIcon, CalendarToday } from "@mui/icons-material";
// // import "./FormDialog.css";

// // const FormDialog = ({
// //   open,
// //   onClose,
// //   title,
// //   fields = [],
// //   initialValues = {},
// //   onSubmit,
// //   viewMode = false,
// //   submitLabel = "Save",
// //   cancelLabel = "Cancel",
// //   profileImage = null,
// //   profileName = null,
// //   showProfileEdit = false,
// //   onProfileEdit = null,
// //   editMode = false,           // true when used in edit dialog
// // }) => {
// //   const [formData, setFormData] = useState(initialValues);
// //   const [errors, setErrors] = useState({});
// //   // const [submitAttempted, setSubmitAttempted] = useState(false);
// //   const [imagePreviews, setImagePreviews] = useState({});

// //   // Which fields are editable in EDIT mode (different per context)
// //   const editableFields = editMode
// //     ? ["email", "phone_number", "name", "code", "address", "city", "state", "country", "postal_code", "contact_email", "contact_phone", "logo"]
// //     : []; // in add mode or view mode we don't use this

// //   // Reset form & errors when dialog opens or initialValues change
// //   useEffect(() => {
// //     if (open) {
// //       setFormData(initialValues);
// //       setErrors({});
// //       // setSubmitAttempted(false); 

// //       // Initialize image previews from existing data
// //       const previews = {};
// //       fields.forEach((field) => {
// //         if (field.type === "file") {
// //           const value = initialValues[field.name];
// //           if (value) {
// //             if (Array.isArray(value)) {
// //               previews[field.name] = value.map((img) => {
// //                 if (typeof img === "string") return img;
// //                 if (img instanceof File) return URL.createObjectURL(img);
// //                 if (img?.url) return img.url; // ✅ handle API objects
// //                 return null;
// //               }).filter(Boolean);
// //             }else if (typeof value === "string") {
// //               previews[field.name] = value;
// //             } else if (value?.url) {
// //               previews[field.name] = value.url;
// //             }
// //           }
// //         }
// //       });
// //       setImagePreviews(previews);
// //     }
// //   }, [initialValues, open, fields]);

// //   const validateForm = () => {
// //     const newErrors = {};
// //     fields.forEach((field) => {
// //       const value = formData[field.name];
// //       let error = "";

// //       if (field.required && !value && value !== 0 && value !== false) {
// //         error = "This field is required";
// //       }

// //       const fieldNameLower = field.name.toLowerCase();
// //       if (
// //         !error &&
// //         (field.type === "tel" ||
// //           fieldNameLower.endsWith("phone") ||
// //           fieldNameLower === "mobile" ||
// //           fieldNameLower === "contact_number" ||
// //           fieldNameLower === "phone_number")
// //       ) {
// //         if (value && (/\s/.test(value) || !/^\+?\d+$/.test(value))) {
// //           error = "Please enter a valid Contact Number.";
// //         }
// //       }

// //       if (!error && field.validate) {
// //         error = field.validate(value, formData) || "";
// //       }

// //       if (error) {
// //         newErrors[field.name] = error;
// //       }
// //     });
// //     setErrors(newErrors);
// //     return Object.keys(newErrors).length === 0;
// //   };

// //   const handleChange = (e) => {
// //     const { name, type, value, files, checked } = e.target;
// //     let newValue;

// //     if (type === "file") {
// //       newValue = files.length > 1 ? Array.from(files) : files[0] || null;
// //     } else if (type === "checkbox") {
// //       newValue = checked;
// //     } else {
// //       newValue = value;
// //     }

// //     setFormData((prev) => {
// //       const updated = { ...prev, [name]: newValue };

// //       // 🔹 Real-time validation
// //       const field = fields.find((f) => f.name === name);
// //       if (field) {
// //         let error = "";

// //         if (field.required && !newValue) {
// //           error = "This field is required";
// //         }

// //         if (!error && field.validate) {
// //           error = field.validate(newValue, updated) || "";
// //         }

// //         setErrors((prevErrors) => ({
// //           ...prevErrors,
// //           [name]: error,
// //         }));
// //       }

// //       return updated;
// //     });
// //   };

// //   const handleMultiSelectChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({
// //       ...prev,
// //       [name]: typeof value === "string" ? value.split(",") : value,
// //     }));
// //   };

// //   const handleDeleteTag = (fieldName, tagToDelete) => {
// //     setFormData((prev) => ({
// //       ...prev,
// //       [fieldName]: prev[fieldName].filter((tag) => tag !== tagToDelete),
// //     }));
// //   };

// //   const handleSubmit = async () => {
// //     // setSubmitAttempted(true);
// //     const isValid = validateForm();

// //     if (!isValid) return;

// //     if (onSubmit && !viewMode) {
// //       const success = await onSubmit(formData);
// //       if (success) onClose();
// //       return;
// //     }
// //     onClose();
// //   };

// //   const isSubmitDisabled = viewMode || Object.keys(errors).length > 0;

// //   // Group fields
// //   const groupedFields = fields.reduce((acc, field) => {
// //     const group = field.group || "General";
// //     if (!acc[group]) acc[group] = [];
// //     acc[group].push(field);
// //     return acc;
// //   }, {});

// //   return (
// //     <Dialog
// //       open={open}
// //       onClose={onClose}
// //       fullWidth
// //       maxWidth="md"
// //       PaperProps={{
// //         sx: {
// //           borderRadius: "12px",
// //           maxHeight: "90vh",
// //           width: "100%",
// //           maxWidth: "800px",
// //         },
// //       }}
// //     >
// //       <DialogTitle
// //         sx={{
// //           padding: "16px 24px",
// //           borderBottom: "1px solid #e5e7eb",
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //         }}
// //       >
// //         <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: 600, color: "#111827" }}>
// //           {title}
// //         </Typography>
// //         <IconButton onClick={onClose} sx={{ color: "#6b7280", padding: "4px" }}>
// //           <CloseIcon fontSize="small" />
// //         </IconButton>
// //       </DialogTitle>

// //       <DialogContent sx={{ padding: "24px", overflowY: "auto" }}>
// //         {(profileImage || profileName) && (
// //           <Box
// //             sx={{
// //               mb: 3,
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //               borderBottom: "1px solid #e5e7eb",
// //               pb: 2,
// //             }}
// //           >
// //             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
// //               <Avatar
// //                 src={profileImage}
// //                 sx={{
// //                   width: 48,
// //                   height: 48,
// //                   border: "2px solid #e5e7eb",
// //                   bgcolor: "#f3f4f6",
// //                   fontSize: "18px",
// //                   fontWeight: 600,
// //                 }}
// //               >
// //                 {profileName?.[0]?.toUpperCase() || ""}
// //               </Avatar>
// //               {profileName && (
// //                 <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}>
// //                   {profileName}
// //                 </Typography>
// //               )}
// //             </Box>
// //             {showProfileEdit && onProfileEdit && (
// //               <Button
// //                 startIcon={<EditIcon sx={{ fontSize: "14px" }} />}
// //                 onClick={onProfileEdit}
// //                 variant="outlined"
// //                 size="small"
// //                 sx={{
// //                   textTransform: "none",
// //                   color: "#374151",
// //                   borderColor: "#d1d5db",
// //                   fontSize: "13px",
// //                   padding: "6px 12px",
// //                   "&:hover": {
// //                     borderColor: "#9ca3af",
// //                     backgroundColor: "#f9fafb",
// //                   },
// //                 }}
// //               >
// //                 Edit Profile
// //               </Button>
// //             )}
// //           </Box>
// //         )}

// //         {Object.entries(groupedFields).map(([group, groupFields], groupIndex) => (
// //           <Box key={groupIndex} sx={{ mb: groupIndex < Object.keys(groupedFields).length - 1 ? 4 : 0 }}>
// //             {Object.keys(groupedFields).length > 1 && (
// //               <Typography
// //                 variant="subtitle1"
// //                 sx={{
// //                   fontSize: "15px",
// //                   fontWeight: 700,
// //                   color: "#374151",
// //                   mb: 2,
// //                 }}
// //               >
// //                 {group}
// //               </Typography>
// //             )}
// //             <Grid container spacing={2}>
// //               {groupFields.map((field, index) => {
// //                 const value = formData[field.name] ?? "";
// //                 const error = errors[field.name] || "";
// //                 const gridWidth = field.gridWidth || 6;

// //                 // Determine if this field should be disabled
// //                 const isFieldDisabled =
// //                   viewMode;

// //                 const showNonEditableMessage = editMode && !viewMode && !editableFields.includes(field.name);

// //                 // File field
// //                 if (field.type === "file") {
// //                   const preview = imagePreviews[field.name];

// //                   return (
// //                     <Grid item xs={12} md={gridWidth} key={index}>
// //                       <Typography
// //                         component="label"
// //                         sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
// //                       >
// //                         {field.label}
// //                         {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
// //                       </Typography>

// //                       {preview && (
// //                         <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
// //                           {Array.isArray(preview) ? (
// //                             preview.map((img, idx) => (
// //                               <img
// //                                 key={idx}
// //                                 src={img}
// //                                 alt={`Preview ${idx + 1}`}
// //                                 style={{
// //                                   width: "100px",
// //                                   height: "100px",
// //                                   objectFit: "cover",
// //                                   borderRadius: "8px",
// //                                   border: "2px solid #e5e7eb",
// //                                 }}
// //                               />
// //                             ))
// //                           ) : (
// //                             <img
// //                               src={preview}
// //                               alt="Preview"
// //                               style={{
// //                                 width: "100px",
// //                                 height: "100px",
// //                                 objectFit: "cover",
// //                                 borderRadius: "8px",
// //                                 border: "2px solid #e5e7eb",
// //                               }}
// //                             />
// //                           )}
// //                         </Box>
// //                       )}

// //                       {isFieldDisabled ? (
// //                         !preview && (
// //                           <Typography sx={{ color: "#9ca3af", fontSize: "13px" }}>
// //                             No image uploaded
// //                           </Typography>
// //                         )
// //                       ) : (
// //                         <Button
// //                           variant="outlined"
// //                           component="label"
// //                           sx={{
// //                             width: "100%",
// //                             height: "40px",
// //                             textTransform: "none",
// //                             borderColor: "#d1d5db",
// //                             color: "#374151",
// //                             fontSize: "13px",
// //                             display: "flex",
// //                             alignItems: "center",
// //                             justifyContent: "flex-start",
// //                             "&:hover": {
// //                               borderColor: "#9ca3af",
// //                               backgroundColor: "#f9fafb",
// //                             },
// //                           }}
// //                         >
// //                           {value
// //                             ? Array.isArray(value)
// //                               ? `${value.length} files selected`
// //                               : value.name || "Change Image"
// //                             : "Choose File"}
// //                           <input
// //                             type="file"
// //                             name={field.name}
// //                             hidden
// //                             onChange={handleChange}
// //                             accept="image/*"
// //                             {...field.inputProps}
// //                           />
// //                         </Button>
// //                       )}

// //                       {error ? (
// //                         <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
// //                           {error}
// //                         </Typography>
// //                       ) : (
// //                         showNonEditableMessage && (
// //                           <Typography sx={{ color: "#9ca3af", fontSize: "12px", mt: 0.5 }}>
// //                             {/* This field cannot be edited. */}
// //                           </Typography>
// //                         )
// //                       )}
// //                     </Grid>
// //                   );
// //                 }
// //                   // CUSTOM FIELD RENDERING
// //                   if (field.type === "custom" && field.customRender) {
// //                     return (
// //                       <Grid item xs={12} md={gridWidth} key={index}>
// //                         <Typography
// //                           component="label"
// //                           sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
// //                         >
// //                           {field.label}
// //                         </Typography>

// //                         {field.customRender(value)}
// //                       </Grid>
// //                     );
// //                   }
// //                 // Checkbox
// //                 if (field.type === "checkbox") {
// //                   return (
// //                     <Grid item xs={12} md={gridWidth} key={index}>
// //                       <FormControlLabel
// //                         control={
// //                           <Checkbox
// //                             name={field.name}
// //                             checked={!!value}
// //                             onChange={handleChange}
// //                             disabled={isFieldDisabled}
// //                             sx={{
// //                               color: "#d1d5db",
// //                               "&.Mui-checked": { color: "#3b82f6" },
// //                               padding: "4px",
// //                             }}
// //                           />
// //                         }
// //                         label={<Typography sx={{ fontSize: "14px", color: "#374151" }}>{field.label}</Typography>}
// //                         sx={{ margin: 0 }}
// //                       />
// //                       {error ? (
// //                         <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
// //                           {error}
// //                         </Typography>
// //                       ) : (
// //                         showNonEditableMessage && (
// //                           <Typography sx={{ color: "#9ca3af", fontSize: "12px", mt: 0.5 }}>
// //                             {/* This field cannot be edited. */}
// //                           </Typography>
// //                         )
// //                       )}
// //                     </Grid>
// //                   );
// //                 }

// //                 // Text, email, select, multiline, etc.
// //                 const isTextLike =
// //                   !field.type ||
// //                   field.type === "text" ||
// //                   field.type === "email" ||
// //                   field.type === "password" ||
// //                   field.type === "date" ||
// //                   field.type === "multiline" ||
// //                   field.type === "textarea" ||
// //                   field.type?.includes("select");

// //                 if (isTextLike) {
// //                   return (
// //                     <Grid item xs={12} md={gridWidth} key={index}>
// //                       <Typography
// //                         component="label"
// //                         sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
// //                       >
// //                         {field.label}
// //                         {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
// //                       </Typography>

// //                       <TextField
// //                         name={field.name}
// //                         type={field.type || "text"}
// //                         variant="outlined"
// //                         fullWidth
// //                         size="medium"
// //                         required={field.required}
// //                         value={value}
// //                         onChange={field.type?.includes("select-multiple") ? handleMultiSelectChange : handleChange}
// //                         disabled={isFieldDisabled}
// //                         select={field.type?.includes("select")}
// //                         multiline={field.type === "multiline" || field.type === "textarea"}
// //                         rows={field.rows}
// //                         autoComplete="off"
// //                         SelectProps={{
// //                           multiple: field.type === "select-multiple",
// //                           displayEmpty: true,
// //                           renderValue:
// //                             field.type === "select-multiple"
// //                               ? (selected) => (
// //                                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
// //                                   {selected.length === 0 ? (
// //                                     <Typography sx={{ color: "#9ca3af", fontSize: "14px" }}>
// //                                       Select {field.label}
// //                                     </Typography>
// //                                   ) : (
// //                                     selected.map((value) => (
// //                                       <Chip
// //                                         key={value}
// //                                         label={field.options?.find((opt) => opt.value === value)?.label || value}
// //                                         size="small"
// //                                         onDelete={!viewMode ? () => handleDeleteTag(field.name, value) : undefined}
// //                                         onMouseDown={(e) => e.stopPropagation()}
// //                                         sx={{
// //                                           height: "24px",
// //                                           fontSize: "12px",
// //                                           backgroundColor: "#eef2ff",
// //                                           color: "#4f46e5",
// //                                           "& .MuiChip-deleteIcon": { color: "#6366f1", fontSize: "14px" },
// //                                         }}
// //                                       />
// //                                     ))
// //                                   )}
// //                                 </Box>
// //                               )
// //                               : (selected) =>
// //                                 field.options?.find((opt) => opt.value === selected)?.label ||
// //                                 selected ||
// //                                 `Select ${field.label}`,
// //                         }}
// //                         InputProps={
// //                           field.type === "date"
// //                             ? {
// //                               startAdornment: <CalendarToday sx={{ mr: 1, fontSize: "16px", color: "#9ca3af" }} />,
// //                             }
// //                             : {}
// //                         }
// //                         error={!!error}
// //                         helperText={
// //                           error ||
// //                           (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
// //                         }
// //                         sx={{
// //                           "& .MuiOutlinedInput-root": {
// //                             backgroundColor: viewMode ? "#f9fafb" : "#fff",
// //                             fontSize: "14px",
// //                             borderRadius: "8px",
// //                             ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
// //                           },
// //                         }}
// //                         {...field.inputProps}
// //                       >
// //                         {field.options?.map((opt) => (
// //                           <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "14px", padding: "8px 16px" }}>
// //                             {opt.label}
// //                           </MenuItem>
// //                         ))}
// //                       </TextField>

// //                       {/* Special message for status field in edit mode */}
// //                       {field.name === "status" && showNonEditableMessage && (
// //                         <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
// //                           Status can only be changed via Activate / Deactivate actions.
// //                         </Typography>
// //                       )}
// //                     </Grid>
// //                   );
// //                 }

// //                 // Custom render (e.g. image preview in view mode)
// //                 if (field.type === "image" && field.render) {
// //                   return (
// //                     <Grid item xs={12} md={gridWidth} key={index}>
// //                       <Typography
// //                         component="label"
// //                         sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
// //                       >
// //                         {field.label}
// //                       </Typography>
// //                       {field.render(value)}
// //                       {error && (
// //                         <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
// //                           {error}
// //                         </Typography>
// //                       )}
// //                     </Grid>
// //                   );
// //                 }

// //                 // Fallback
// //                 return (
// //                   <Grid item xs={12} md={gridWidth} key={index}>
// //                     <Typography
// //                       component="label"
// //                       sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
// //                     >
// //                       {field.label}
// //                       {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
// //                     </Typography>
// //                     <TextField
// //                       name={field.name}
// //                       type={field.type || "text"}
// //                       variant="outlined"
// //                       fullWidth
// //                       size="medium"
// //                       required={field.required}
// //                       value={value}
// //                       onChange={handleChange}
// //                       disabled={isFieldDisabled}
// //                       placeholder={field.placeholder}
// //                       inputProps={field.inputProps}
// //                       error={!!error}
// //                       helperText={
// //                         error ||
// //                         (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
// //                       }
// //                       autoComplete="off"
// //                       sx={{
// //                         "& .MuiOutlinedInput-root": {
// //                           backgroundColor: viewMode ? "#f9fafb" : "#fff",
// //                           fontSize: "14px",
// //                           borderRadius: "8px",
// //                           ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
// //                         },
// //                       }}
// //                     />
// //                   </Grid>
// //                 );
// //               })}
// //             </Grid>
// //           </Box>
// //         ))}
// //       </DialogContent>

// //      <DialogActions
// //         sx={{
// //           padding: "16px 24px",
// //           borderTop: "1px solid #e5e7eb",
// //           display: "flex",
// //           gap: 2,
// //           justifyContent: "flex-end",
// //         }}
// //       >
// //         {viewMode ? (
// //           <Button
// //             onClick={onClose}
// //             variant="contained"
// //             sx={{
// //               minWidth: "100px",
// //               height: "36px",
// //               textTransform: "none",
// //               backgroundColor: "#111827",
// //               color: "#fff",
// //               fontSize: "14px",
// //               fontWeight: 500,
// //               borderRadius: "8px",
// //               boxShadow: "none",
// //             }}
// //           >
// //             {cancelLabel}
// //           </Button>
// //         ) : (
// //           <>
// //             <Button
// //               onClick={onClose}
// //               variant="outlined"
// //               sx={{
// //                 minWidth: "100px",
// //                 height: "36px",
// //                 textTransform: "none",
// //                 color: "#374151",
// //                 borderColor: "#d1d5db",
// //                 fontSize: "14px",
// //                 fontWeight: 500,
// //                 borderRadius: "8px",
// //               }}
// //             >
// //               {cancelLabel}
// //             </Button>

// //             <Button
// //               onClick={handleSubmit}
// //               variant="contained"
// //               disabled={Object.keys(errors).length > 0}
// //               sx={{
// //                 minWidth: "100px",
// //                 height: "36px",
// //                 textTransform: "none",
// //                 backgroundColor: "#111827",
// //                 color: "#fff",
// //                 fontSize: "14px",
// //                 fontWeight: 500,
// //                 borderRadius: "8px",
// //                 boxShadow: "none",
// //                 "&:disabled": {
// //                   backgroundColor: "#d1d5db",
// //                   color: "#6b7280",
// //                 },
// //               }}
// //             >
// //               {submitLabel}
// //             </Button>
// //           </>
// //         )}
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default FormDialog;

// // Updated FormDialog.jsx
// // Key Changes for Edit Form Issues:
// // - Expanded editableFields to include ALL user-specific fields (first_name, last_name, etc.) 
// //   so no "cannot be edited" messages appear for valid edit fields.
// // - Removed showNonEditableMessage logic entirely for user edit context (it's too restrictive 
// //   and was blocking edits). Now all fields in editFields are fully editable.
// // - In handleEditUserSubmit (from UserManagement): Only append non-empty values to FormData 
// //   (PATCH-friendly). Added check to exclude unchanged fields if they match initialValues.
// // - Added better error handling/logging in handleEditUserSubmit to debug why edits might fail.
// // - For role/organization: Made them editable in edit mode (API supports it, but add 
// //   confirmation if needed). If role changes should be restricted, add a custom validate.
// // - Other minor: Ensured file uploads work in edit (clears old image if new file selected).
// // - No breaking changes: Existing add/view modes unchanged.

//   import React, { useState, useEffect } from "react";
//   import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     Button,
//     Grid,
//     MenuItem,
//     Avatar,
//     Box,
//     Typography,
//     Chip,
//     IconButton,
//     FormControlLabel,
//     Checkbox,
//     InputAdornment,
//   } from "@mui/material";
//   import Visibility from "@mui/icons-material/Visibility";
//   import VisibilityOff from "@mui/icons-material/VisibilityOff";
//   import { Edit as EditIcon, Close as CloseIcon, CalendarToday } from "@mui/icons-material";
//   import "./FormDialog.css";

//   const FormDialog = ({
//     open,
//     onClose,
//     title,
//     fields = [],
//     initialValues = {},
//     onSubmit,
//     viewMode = false,
//     submitLabel = "Save",
//     cancelLabel = "Cancel",
//     profileImage = null,
//     profileName = null,
//     showProfileEdit = false,
//     onProfileEdit = null,
//     editMode = false, // true when used in edit dialog
//   }) => {
//     const [formData, setFormData] = useState(initialValues);
//     const [errors, setErrors] = useState({});
//     const [submitAttempted, setSubmitAttempted] = useState(false);
//     const [imagePreviews, setImagePreviews] = useState({});
//     const [passwordVisibility, setPasswordVisibility] = useState({});

//     // Updated: Expanded for user edit fields; made more generic
//     const editableFields = editMode
//       ? [
//           "email", "phone_number", "first_name", "middle_name", "last_name",
//           "address_line_1", "city", "state", "country", "postal_code",
//           "role", "organization", "profile_picture", // Include role/org if API allows
//           // Add more if needed for other forms (name, code, etc.)
//           "name", "code", "address", "contact_email", "contact_phone", "logo"
//         ]
//       : [];

//     // Reset form & errors when dialog opens or initialValues change
//     useEffect(() => {
//       if (open) {
//         setFormData(initialValues);
//         setErrors({});
//         setSubmitAttempted(false);
//         setPasswordVisibility({});
//         // Initialize image previews from existing data
//         const previews = {};
//         fields.forEach((field) => {
//           if (field.type === "file") {
//             const value = initialValues[field.name];
//             if (value) {
//               if (Array.isArray(value)) {
//                 previews[field.name] = value.map((img) => {
//                   if (typeof img === "string") return img;
//                   if (img instanceof File) return URL.createObjectURL(img);
//                   if (img?.url) return img.url;
//                   return null;
//                 }).filter(Boolean);
//               } else if (typeof value === "string") {
//                 previews[field.name] = value;
//               } else if (value?.url) {
//                 previews[field.name] = value.url;
//               }
//             }
//           }
//         });
//         setImagePreviews(previews);
//       }
//     }, [initialValues, open, fields]);

//     // Initial validation for required fields on open (shows errors immediately)
//     useEffect(() => {
//       if (open && !viewMode) {
//         const initialErrors = {};
//         fields.forEach((field) => {
//           const value = formData[field.name];
//           let error = "";
//           if (field.required && !value && value !== false && value !== 0) {
//             error = "This field is required";
//           }
//           if (!error && field.validate) {
//             error = field.validate(value, formData) || "";
//           }
//           if (error) initialErrors[field.name] = error;
//         });
//         setErrors(initialErrors);
//       }
//     }, [open, viewMode, fields, formData]);

//     const validateForm = () => {
//       const newErrors = {};
//       fields.forEach((field) => {
//         const value = formData[field.name];
//         let error = "";
//         if (field.required && !value && value !== 0 && value !== false) {
//           error = "This field is required";
//         }
//         const fieldNameLower = field.name.toLowerCase();
//         if (
//           !error &&
//           (field.type === "tel" ||
//             fieldNameLower.endsWith("phone") ||
//             fieldNameLower === "mobile" ||
//             fieldNameLower === "contact_number" ||
//             fieldNameLower === "phone_number")
//         ) {
//           if (value && (/\s/.test(value) || !/^\+?\d+$/.test(value))) {
//             error = "Please enter a valid Contact Number.";
//           }
//         }
//         // File-specific validation
//         if (field.type === "file" && value instanceof File) {
//           if (field.validate) {
//             error = field.validate(value, formData) || "";
//           }
//         }
//         if (!error && field.validate) {
//           error = field.validate(value, formData) || "";
//         }
//         if (error) {
//           newErrors[field.name] = error;
//         }
//       });
//       setErrors(newErrors);
//       return Object.keys(newErrors).length === 0;
//     };

//     const handleChange = (e) => {
//       const { name, type, value, files, checked } = e.target;
//       let newValue;
//       if (type === "file") {
//         newValue = files.length > 1 ? Array.from(files) : files[0] || null;
//         // Immediate file validation
//         const field = fields.find((f) => f.name === name);
//         if (newValue && field && field.validate) {
//           const fileError = field.validate(newValue, { ...formData, [name]: newValue });
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: fileError,
//           }));
//         }
//       } else if (type === "checkbox") {
//         newValue = checked;
//       } else {
//         newValue = value;
//       }
//       setFormData((prev) => {
//         const updated = { ...prev, [name]: newValue };
//         // Real-time validation on every change
//         const field = fields.find((f) => f.name === name);
//         if (field) {
//           let error = "";
//           if (field.required && !newValue && newValue !== false && newValue !== 0) {
//             error = "This field is required";
//           }
//           if (!error && field.validate) {
//             error = field.validate(newValue, updated) || "";
//           }
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: error,
//           }));
//         }
//         return updated;
//       });
//     };

//     const togglePasswordVisibility = (fieldName) => {
//       setPasswordVisibility((prev) => ({
//         ...prev,
//         [fieldName]: !prev[fieldName],
//       }));
//     };

//     const handleMultiSelectChange = (e) => {
//       const { name, value } = e.target;
//       setFormData((prev) => ({
//         ...prev,
//         [name]: typeof value === "string" ? value.split(",") : value,
//       }));
//     };

//     const handleDeleteTag = (fieldName, tagToDelete) => {
//       setFormData((prev) => ({
//         ...prev,
//         [fieldName]: prev[fieldName].filter((tag) => tag !== tagToDelete),
//       }));
//     };

//     const handleSubmit = async () => {
//       setSubmitAttempted(true);
//       const isValid = validateForm();
//       if (!isValid) {
//         // Scroll to first error
//         const firstErrorField = document.querySelector('.Mui-error');
//         if (firstErrorField) firstErrorField.scrollIntoView({ behavior: 'smooth' });
//         return;
//       }
//       if (onSubmit && !viewMode) {
//         const success = await onSubmit(formData);
//         if (success !== false) onClose(); // Assume success unless explicitly false
//         return;
//       }
//       onClose();
//     };

//     // Updated: Button enabled if no errors (removed !submitAttempted dependency)
//     const isSubmitDisabled = viewMode || Object.keys(errors).length > 0;

//     // Group fields
//     const groupedFields = fields.reduce((acc, field) => {
//       const group = field.group || "General";
//       if (!acc[group]) acc[group] = [];
//       acc[group].push(field);
//       return acc;
//     }, {});

//     // Updated: No showNonEditableMessage for user edit (all fields editable)
//     const showNonEditableMessage = false; // Disabled for now; re-enable per-field if needed

//     return (
//       <Dialog
//         open={open}
//         onClose={onClose}
//         fullWidth
//         maxWidth="md"
//         PaperProps={{
//           sx: {
//             borderRadius: "12px",
//             maxHeight: "90vh",
//             width: "100%",
//             maxWidth: "800px",
//           },
//         }}
//       >
//         {/* Fixed: Direct text in DialogTitle to avoid h2 > h6 nesting */}
//         <DialogTitle
//           sx={{
//             padding: "16px 24px",
//             borderBottom: "1px solid #e5e7eb",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             fontSize: "18px",
//             fontWeight: 600,
//             color: "#111827",
//           }}
//         >
//           {title}
//           <IconButton onClick={onClose} sx={{ color: "#6b7280", padding: "4px" }}>
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ padding: "24px", overflowY: "auto" }}>
//           {(profileImage || profileName) && (
//             <Box
//               sx={{
//                 mb: 3,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 borderBottom: "1px solid #e5e7eb",
//                 pb: 2,
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <Avatar
//                   src={profileImage}
//                   sx={{
//                     width: 48,
//                     height: 48,
//                     border: "2px solid #e5e7eb",
//                     bgcolor: "#f3f4f6",
//                     fontSize: "18px",
//                     fontWeight: 600,
//                   }}
//                 >
//                   {profileName?.[0]?.toUpperCase() || ""}
//                 </Avatar>
//                 {profileName && (
//                   <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}>
//                     {profileName}
//                   </Typography>
//                 )}
//               </Box>
//               {showProfileEdit && onProfileEdit && (
//                 <Button
//                   startIcon={<EditIcon sx={{ fontSize: "14px" }} />}
//                   onClick={onProfileEdit}
//                   variant="outlined"
//                   size="small"
//                   sx={{
//                     textTransform: "none",
//                     color: "#374151",
//                     borderColor: "#d1d5db",
//                     fontSize: "13px",
//                     padding: "6px 12px",
//                     "&:hover": {
//                       borderColor: "#9ca3af",
//                       backgroundColor: "#f9fafb",
//                     },
//                   }}
//                 >
//                   Edit Profile
//                 </Button>
//               )}
//             </Box>
//           )}
//           {Object.entries(groupedFields).map(([group, groupFields], groupIndex) => (
//             <Box key={groupIndex} sx={{ mb: groupIndex < Object.keys(groupedFields).length - 1 ? 4 : 0 }}>
//               {Object.keys(groupedFields).length > 1 && (
//                 <Typography
//                   sx={{
//                     fontSize: "15px",
//                     fontWeight: 700,
//                     color: "#374151",
//                     mb: 2,
//                   }}
//                 >
//                   {group}
//                 </Typography>
//               )}
//               {/* Fixed: Updated Grid v2 syntax (size={{ xs: ..., md: ... }}) to silence warnings */}
//               <Grid container spacing={2}>
//                 {groupFields.map((field, index) => {
//                   const value = formData[field.name] ?? "";
//                   const error = errors[field.name] || "";
//                   const gridWidth = field.gridWidth || 6;
//                   const isFieldDisabled = viewMode;
//                   // File field
//                   if (field.type === "file") {
//                     const preview = imagePreviews[field.name];
//                     return (
//                       <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                         <Typography
//                           sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
//                         >
//                           {field.label}
//                           {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
//                         </Typography>
//                         {preview && (
//                           <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
//                             {Array.isArray(preview) ? (
//                               preview.map((img, idx) => (
//                                 <img
//                                   key={idx}
//                                   src={img}
//                                   alt={`Preview ${idx + 1}`}
//                                   style={{
//                                     width: "100px",
//                                     height: "100px",
//                                     objectFit: "cover",
//                                     borderRadius: "8px",
//                                     border: "2px solid #e5e7eb",
//                                   }}
//                                 />
//                               ))
//                             ) : (
//                               <img
//                                 src={preview}
//                                 alt="Preview"
//                                 style={{
//                                   width: "100px",
//                                   height: "100px",
//                                   objectFit: "cover",
//                                   borderRadius: "8px",
//                                   border: "2px solid #e5e7eb",
//                                 }}
//                               />
//                             )}
//                           </Box>
//                         )}
//                         {isFieldDisabled ? (
//                           !preview && (
//                             <Typography sx={{ color: "#9ca3af", fontSize: "13px" }}>
//                               No image uploaded
//                             </Typography>
//                           )
//                         ) : (
//                           <Button
//                             variant="outlined"
//                             component="label"
//                             sx={{
//                               width: "100%",
//                               height: "40px",
//                               textTransform: "none",
//                               borderColor: "#d1d5db",
//                               color: "#374151",
//                               fontSize: "13px",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "flex-start",
//                               "&:hover": {
//                                 borderColor: "#9ca3af",
//                                 backgroundColor: "#f9fafb",
//                               },
//                             }}
//                           >
//                             {value
//                               ? Array.isArray(value)
//                                 ? `${value.length} files selected`
//                                 : value.name || "Change Image"
//                               : "Choose File"}
//                             <input
//                               type="file"
//                               name={field.name}
//                               hidden
//                               onChange={handleChange}
//                               accept="image/*"
//                               {...field.inputProps}
//                             />
//                           </Button>
//                         )}
//                         {error ? (
//                           <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.2 }}>
//                             {error}
//                           </Typography>
//                         ) : null}
//                       </Grid>
//                     );
//                   }
//                   // CUSTOM FIELD RENDERING
//                   if (field.type === "custom" && field.customRender) {
//                     return (
//                       <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                         <Typography
//                           sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
//                         >
//                           {field.label}
//                         </Typography>
//                         {field.customRender(value)}
//                       </Grid>
//                     );
//                   }
//                   // Checkbox
//                   if (field.type === "checkbox") {
//                     return (
//                       <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               name={field.name}
//                               checked={!!value}
//                               onChange={handleChange}
//                               disabled={isFieldDisabled}
//                               sx={{
//                                 color: "#d1d5db",
//                                 "&.Mui-checked": { color: "#3b82f6" },
//                                 padding: "4px",
//                               }}
//                             />
//                           }
//                           label={<Typography sx={{ fontSize: "14px", color: "#374151" }}>{field.label}</Typography>}
//                           sx={{ margin: 0 }}
//                         />
//                         {error ? (
//                           <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
//                             {error}
//                           </Typography>
//                         ) : null}
//                       </Grid>
//                     );
//                   }
//                   // Text, email, select, multiline, etc.
//                   const isTextLike =
//                     !field.type ||
//                     field.type === "text" ||
//                     field.type === "email" ||
//                     field.type === "password" ||
//                     field.type === "date" ||
//                     field.type === "multiline" ||
//                     field.type === "textarea" ||
//                     field.type?.includes("select");
//                   if (isTextLike) {
//                     const isPassword = field.type === "password";
//                     const showPassword = isPassword ? passwordVisibility[field.name] || false : false;
//                     return (
//                       <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                         <Typography
//                           sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
//                         >
//                           {field.label}
//                           {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
//                         </Typography>
//                         <TextField
//                           name={field.name}
//                           type={isPassword ? (showPassword ? "text" : "password") : (field.type || "text")}
//                           variant="outlined"
//                           fullWidth
//                           size="medium"
//                           required={field.required}
//                           value={value}
//                           onChange={field.type?.includes("select-multiple") ? handleMultiSelectChange : handleChange}
//                           disabled={isFieldDisabled}
//                           select={field.type?.includes("select")}
//                           multiline={field.type === "multiline" || field.type === "textarea"}
//                           rows={field.rows}
//                           autoComplete="off"
//                           SelectProps={{
//                             multiple: field.type === "select-multiple",
//                             displayEmpty: true,
//                             renderValue:
//                               field.type === "select-multiple"
//                                 ? (selected) => (
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                                       {selected.length === 0 ? (
//                                         <Typography sx={{ color: "#9ca3af", fontSize: "14px" }}>
//                                           Select {field.label}
//                                         </Typography>
//                                       ) : (
//                                         selected.map((value) => (
//                                           <Chip
//                                             key={value}
//                                             label={field.options?.find((opt) => opt.value === value)?.label || value}
//                                             size="small"
//                                             onDelete={!viewMode ? () => handleDeleteTag(field.name, value) : undefined}
//                                             onMouseDown={(e) => e.stopPropagation()}
//                                             sx={{
//                                               height: "24px",
//                                               fontSize: "12px",
//                                               backgroundColor: "#eef2ff",
//                                               color: "#4f46e5",
//                                               "& .MuiChip-deleteIcon": { color: "#6366f1", fontSize: "14px" },
//                                             }}
//                                           />
//                                         ))
//                                       )}
//                                     </Box>
//                                   )
//                                 : (selected) =>
//                                   field.options?.find((opt) => opt.value === selected)?.label ||
//                                   selected ||
//                                   `Select ${field.label}`,
//                           }}
//                           InputProps={{
//                             ...(field.type === "date"
//                               ? {
//                                   startAdornment: <CalendarToday sx={{ mr: 1, fontSize: "16px", color: "#9ca3af" }} />,
//                                 }
//                               : {}),
//                             ...(isPassword
//                               ? {
//                                   endAdornment: (
//                                     <InputAdornment position="end">
//                                       <IconButton
//                                         onClick={() => togglePasswordVisibility(field.name)}
//                                         edge="end"
//                                         size="small"
//                                       >
//                                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                                       </IconButton>
//                                     </InputAdornment>
//                                   ),
//                                 }
//                               : {}),
//                           }}
//                           error={!!error}
//                           helperText={
//                             error ||
//                             (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
//                           }
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               backgroundColor: viewMode ? "#f9fafb" : "#fff",
//                               fontSize: "14px",
//                               borderRadius: "8px",
//                               ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
//                             },
//                           }}
//                           {...field.inputProps}
//                         >
//                           {field.options?.map((opt) => (
//                             <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "14px", padding: "8px 16px" }}>
//                               {opt.label}
//                             </MenuItem>
//                           ))}
//                         </TextField>
//                         {field.name === "status" && showNonEditableMessage && (
//                           <Typography sx={{ mt: 0.5, display: "block" }}>
//                             Status can only be changed via Activate / Deactivate actions.
//                           </Typography>
//                         )}
//                       </Grid>
//                     );
//                   }
//                   // Custom render (e.g. image preview in view mode)
//                   if (field.type === "image" && field.render) {
//                     return (
//                       <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                         <Typography
//                           sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
//                         >
//                           {field.label}
//                         </Typography>
//                         {field.render(value)}
//                         {error && (
//                           <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
//                             {error}
//                           </Typography>
//                         )}
//                       </Grid>
//                     );
//                   }
//                   // Fallback
//                   return (
//                     <Grid size={{ xs: 12, md: gridWidth }} key={index}>
//                       <Typography
//                         sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
//                       >
//                         {field.label}
//                         {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
//                       </Typography>
//                       <TextField
//                         name={field.name}
//                         type={field.type || "text"}
//                         variant="outlined"
//                         fullWidth
//                         size="medium"
//                         required={field.required}
//                         value={value}
//                         onChange={handleChange}
//                         disabled={isFieldDisabled}
//                         placeholder={field.placeholder}
//                         inputProps={field.inputProps}
//                         error={!!error}
//                         helperText={
//                           error ||
//                           (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
//                         }
//                         autoComplete="off"
//                         sx={{
//                           "& .MuiOutlinedInput-root": {
//                             backgroundColor: viewMode ? "#f9fafb" : "#fff",
//                             fontSize: "14px",
//                             borderRadius: "8px",
//                             ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
//                           },
//                         }}
//                       />
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             </Box>
//           ))}
//         </DialogContent>
//         <DialogActions
//           sx={{
//             padding: "16px 24px",
//             borderTop: "1px solid #e5e7eb",
//             display: "flex",
//             gap: 2,
//             justifyContent: "flex-end",
//           }}
//         >
//           {viewMode ? (
//             <Button
//               onClick={onClose}
//               variant="contained"
//               sx={{
//                 minWidth: "100px",
//                 height: "36px",
//                 textTransform: "none",
//                 backgroundColor: "#111827",
//                 color: "#fff",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 borderRadius: "8px",
//                 boxShadow: "none",
//               }}
//             >
//               {cancelLabel}
//             </Button>
//           ) : (
//             <>
//               <Button
//                 onClick={onClose}
//                 variant="outlined"
//                 sx={{
//                   minWidth: "100px",
//                   height: "36px",
//                   textTransform: "none",
//                   color: "#374151",
//                   borderColor: "#d1d5db",
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   borderRadius: "8px",
//                 }}
//               >
//                 {cancelLabel}
//               </Button>
//               <Button
//                 onClick={handleSubmit}
//                 variant="contained"
//                 disabled={isSubmitDisabled}
//                 sx={{
//                   minWidth: "100px",
//                   height: "36px",
//                   textTransform: "none",
//                   backgroundColor: "#111827",
//                   color: "#fff",
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   borderRadius: "8px",
//                   boxShadow: "none",
//                   "&:disabled": {
//                     backgroundColor: "#d1d5db",
//                     color: "#6b7280",
//                     cursor: "not-allowed",
//                   },
//                 }}
//               >
//                 {submitLabel}
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   export default FormDialog;
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  MenuItem,
  Avatar,
  Box,
  Typography,
  Chip,
  IconButton,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Edit as EditIcon, Close as CloseIcon, CalendarToday } from "@mui/icons-material";
import "./FormDialog.css";

const FormDialog = ({
  open,
  onClose,
  title,
  fields = [],
  initialValues = {},
  onSubmit,
  onChange = null, // ← parent change handler — call this so parent can update its fields array
  viewMode = false,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  profileImage = null,
  profileName = null,
  showProfileEdit = false,
  onProfileEdit = null,
  editMode = false,
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [imagePreviews, setImagePreviews] = useState({});
  const [passwordVisibility, setPasswordVisibility] = useState({});

  const editableFields = editMode
    ? [
        "email", "phone_number", "first_name", "middle_name", "last_name",
        "address_line_1", "city", "state", "country", "postal_code",
        "role", "organization", "profile_picture",
        "name", "code", "address", "contact_email", "contact_phone", "logo"
      ]
    : [];

  // Reset form when dialog opens
  useEffect(() => {
    if (open) {
      setFormData(initialValues);
      setErrors({});
      setSubmitAttempted(false);
      setPasswordVisibility({});
      const previews = {};
      fields.forEach((field) => {
        if (field.type === "file") {
          const value = initialValues[field.name];
          if (value) {
            if (Array.isArray(value)) {
              previews[field.name] = value.map((img) => {
                if (typeof img === "string") return img;
                if (img instanceof File) return URL.createObjectURL(img);
                if (img?.url) return img.url;
                return null;
              }).filter(Boolean);
            } else if (typeof value === "string") {
              previews[field.name] = value;
            } else if (value?.url) {
              previews[field.name] = value.url;
            }
          }
        }
      });
      setImagePreviews(previews);
    }
  }, [open]); // ← intentionally only on open change, NOT on initialValues/fields

  // Sync formData when initialValues change while dialog is open
  // (e.g. parent clears overage fields when allows_overage is unchecked)
  useEffect(() => {
    if (open) {
      setFormData((prev) => ({ ...prev, ...initialValues }));
    }
  }, [initialValues]);

  useEffect(() => {
    if (open && !viewMode) {
      const initialErrors = {};
      fields.forEach((field) => {
        const value = formData[field.name];
        let error = "";
        if (field.required && !value && value !== false && value !== 0) {
          error = "This field is required";
        }
        if (!error && field.validate) {
          error = field.validate(value, formData) || "";
        }
        if (error) initialErrors[field.name] = error;
      });
      setErrors(initialErrors);
    }
  }, [open, viewMode, fields, formData]);

  const validateForm = () => {
    const newErrors = {};
    fields.forEach((field) => {
      const value = formData[field.name];
      let error = "";
      if (field.required && !value && value !== 0 && value !== false) {
        error = "This field is required";
      }
      const fieldNameLower = field.name.toLowerCase();
      if (
        !error &&
        (field.type === "tel" ||
          fieldNameLower.endsWith("phone") ||
          fieldNameLower === "mobile" ||
          fieldNameLower === "contact_number" ||
          fieldNameLower === "phone_number")
      ) {
        if (value && (/\s/.test(value) || !/^\+?\d+$/.test(value))) {
          error = "Please enter a valid Contact Number.";
        }
      }
      if (field.type === "file" && value instanceof File) {
        if (field.validate) {
          error = field.validate(value, formData) || "";
        }
      }
      if (!error && field.validate) {
        error = field.validate(value, formData) || "";
      }
      if (error) {
        newErrors[field.name] = error;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, type, value, files, checked } = e.target;
    let newValue;
    if (type === "file") {
      newValue = files.length > 1 ? Array.from(files) : files[0] || null;
      const field = fields.find((f) => f.name === name);
      if (newValue && field && field.validate) {
        const fileError = field.validate(newValue, { ...formData, [name]: newValue });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: fileError }));
      }
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setFormData((prev) => {
      const updated = { ...prev, [name]: newValue };
      const field = fields.find((f) => f.name === name);
      if (field) {
        let error = "";
        if (field.required && !newValue && newValue !== false && newValue !== 0) {
          error = "This field is required";
        }
        if (!error && field.validate) {
          error = field.validate(newValue, updated) || "";
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
      }
      return updated;
    });

    // ← KEY FIX: notify parent so it can recompute its fields array
    if (onChange) {
      onChange(e);
    }
  };

  const togglePasswordVisibility = (fieldName) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  const handleMultiSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleDeleteTag = (fieldName, tagToDelete) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: prev[fieldName].filter((tag) => tag !== tagToDelete),
    }));
  };

  const handleSubmit = async () => {
    setSubmitAttempted(true);
    const isValid = validateForm();
    if (!isValid) {
      const firstErrorField = document.querySelector('.Mui-error');
      if (firstErrorField) firstErrorField.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (onSubmit && !viewMode) {
      const success = await onSubmit(formData);
      if (success !== false) onClose();
      return;
    }
    onClose();
  };

  const isSubmitDisabled = viewMode || Object.keys(errors).length > 0;

  const groupedFields = fields.reduce((acc, field) => {
    const group = field.group || "General";
    if (!acc[group]) acc[group] = [];
    acc[group].push(field);
    return acc;
  }, {});

  const showNonEditableMessage = false;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxHeight: "90vh",
          width: "100%",
          maxWidth: "800px",
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: "16px 24px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: 600,
          color: "#111827",
        }}
      >
        {title}
        <IconButton onClick={onClose} sx={{ color: "#6b7280", padding: "4px" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "24px", overflowY: "auto" }}>
        {(profileImage || profileName) && (
          <Box
            sx={{
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #e5e7eb",
              pb: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Avatar
                src={profileImage}
                sx={{
                  width: 48,
                  height: 48,
                  border: "2px solid #e5e7eb",
                  bgcolor: "#f3f4f6",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                {profileName?.[0]?.toUpperCase() || ""}
              </Avatar>
              {profileName && (
                <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}>
                  {profileName}
                </Typography>
              )}
            </Box>
            {showProfileEdit && onProfileEdit && (
              <Button
                startIcon={<EditIcon sx={{ fontSize: "14px" }} />}
                onClick={onProfileEdit}
                variant="outlined"
                size="small"
                sx={{
                  textTransform: "none",
                  color: "#374151",
                  borderColor: "#d1d5db",
                  fontSize: "13px",
                  padding: "6px 12px",
                  "&:hover": {
                    borderColor: "#9ca3af",
                    backgroundColor: "#f9fafb",
                  },
                }}
              >
                Edit Profile
              </Button>
            )}
          </Box>
        )}
        {Object.entries(groupedFields).map(([group, groupFields], groupIndex) => (
          <Box key={groupIndex} sx={{ mb: groupIndex < Object.keys(groupedFields).length - 1 ? 4 : 0 }}>
            {Object.keys(groupedFields).length > 1 && (
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#374151",
                  mb: 2,
                }}
              >
                {group}
              </Typography>
            )}
            <Grid container spacing={2}>
              {groupFields.map((field, index) => {
                const value = formData[field.name] ?? "";
                const error = errors[field.name] || "";
                const gridWidth = field.gridWidth || 6;
                const isFieldDisabled = viewMode;

                if (field.type === "file") {
                  const preview = imagePreviews[field.name];
                  return (
                    <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                      <Typography
                        sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
                      >
                        {field.label}
                        {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
                      </Typography>
                      {preview && (
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                          {Array.isArray(preview) ? (
                            preview.map((img, idx) => (
                              <img
                                key={idx}
                                src={img}
                                alt={`Preview ${idx + 1}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "2px solid #e5e7eb",
                                }}
                              />
                            ))
                          ) : (
                            <img
                              src={preview}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "2px solid #e5e7eb",
                              }}
                            />
                          )}
                        </Box>
                      )}
                      {isFieldDisabled ? (
                        !preview && (
                          <Typography sx={{ color: "#9ca3af", fontSize: "13px" }}>
                            No image uploaded
                          </Typography>
                        )
                      ) : (
                        <Button
                          variant="outlined"
                          component="label"
                          sx={{
                            width: "100%",
                            height: "40px",
                            textTransform: "none",
                            borderColor: "#d1d5db",
                            color: "#374151",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            "&:hover": {
                              borderColor: "#9ca3af",
                              backgroundColor: "#f9fafb",
                            },
                          }}
                        >
                          {value
                            ? Array.isArray(value)
                              ? `${value.length} files selected`
                              : value.name || "Change Image"
                            : "Choose File"}
                          <input
                            type="file"
                            name={field.name}
                            hidden
                            onChange={handleChange}
                            accept="image/*"
                            {...field.inputProps}
                          />
                        </Button>
                      )}
                      {error ? (
                        <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.2 }}>
                          {error}
                        </Typography>
                      ) : null}
                    </Grid>
                  );
                }

                if (field.type === "custom" && field.customRender) {
                  return (
                    <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                      <Typography
                        sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
                      >
                        {field.label}
                      </Typography>
                      {field.customRender(value)}
                    </Grid>
                  );
                }

                if (field.type === "checkbox") {
                  return (
                    <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={field.name}
                            checked={!!value}
                            onChange={handleChange}
                            disabled={isFieldDisabled}
                            sx={{
                              color: "#d1d5db",
                              "&.Mui-checked": { color: "#3b82f6" },
                              padding: "4px",
                            }}
                          />
                        }
                        label={<Typography sx={{ fontSize: "14px", color: "#374151" }}>{field.label}</Typography>}
                        sx={{ margin: 0 }}
                      />
                      {error ? (
                        <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
                          {error}
                        </Typography>
                      ) : null}
                    </Grid>
                  );
                }

                const isTextLike =
                  !field.type ||
                  field.type === "text" ||
                  field.type === "email" ||
                  field.type === "password" ||
                  field.type === "date" ||
                  field.type === "multiline" ||
                  field.type === "textarea" ||
                  field.type?.includes("select");

                if (isTextLike) {
                  const isPassword = field.type === "password";
                  const showPassword = isPassword ? passwordVisibility[field.name] || false : false;
                  return (
                    <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                      <Typography
                        sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
                      >
                        {field.label}
                        {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
                      </Typography>
                      <TextField
                        name={field.name}
                        type={isPassword ? (showPassword ? "text" : "password") : (field.type || "text")}
                        variant="outlined"
                        fullWidth
                        size="medium"
                        required={field.required}
                        value={value}
                        onChange={field.type?.includes("select-multiple") ? handleMultiSelectChange : handleChange}
                        disabled={isFieldDisabled}
                        select={field.type?.includes("select")}
                        multiline={field.type === "multiline" || field.type === "textarea"}
                        rows={field.rows}
                        autoComplete="off"
                        SelectProps={{
                          multiple: field.type === "select-multiple",
                          displayEmpty: true,
                          renderValue:
                            field.type === "select-multiple"
                              ? (selected) => (
                                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.length === 0 ? (
                                      <Typography sx={{ color: "#9ca3af", fontSize: "14px" }}>
                                        Select {field.label}
                                      </Typography>
                                    ) : (
                                      selected.map((value) => (
                                        <Chip
                                          key={value}
                                          label={field.options?.find((opt) => opt.value === value)?.label || value}
                                          size="small"
                                          onDelete={!viewMode ? () => handleDeleteTag(field.name, value) : undefined}
                                          onMouseDown={(e) => e.stopPropagation()}
                                          sx={{
                                            height: "24px",
                                            fontSize: "12px",
                                            backgroundColor: "#eef2ff",
                                            color: "#4f46e5",
                                            "& .MuiChip-deleteIcon": { color: "#6366f1", fontSize: "14px" },
                                          }}
                                        />
                                      ))
                                    )}
                                  </Box>
                                )
                              : (selected) =>
                                field.options?.find((opt) => opt.value === selected)?.label ||
                                selected ||
                                `Select ${field.label}`,
                        }}
                        InputProps={{
                          ...(field.type === "date"
                            ? {
                                startAdornment: <CalendarToday sx={{ mr: 1, fontSize: "16px", color: "#9ca3af" }} />,
                              }
                            : {}),
                          ...(isPassword
                            ? {
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => togglePasswordVisibility(field.name)}
                                      edge="end"
                                      size="small"
                                    >
                                      {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }
                            : {}),
                        }}
                        error={!!error}
                        helperText={
                          error ||
                          (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: viewMode ? "#f9fafb" : "#fff",
                            fontSize: "14px",
                            borderRadius: "8px",
                            ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
                          },
                        }}
                        {...field.inputProps}
                      >
                        {field.options?.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "14px", padding: "8px 16px" }}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      {field.name === "status" && showNonEditableMessage && (
                        <Typography sx={{ mt: 0.5, display: "block" }}>
                          Status can only be changed via Activate / Deactivate actions.
                        </Typography>
                      )}
                    </Grid>
                  );
                }

                if (field.type === "image" && field.render) {
                  return (
                    <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                      <Typography
                        sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
                      >
                        {field.label}
                      </Typography>
                      {field.render(value)}
                      {error && (
                        <Typography sx={{ color: "#ef4444", fontSize: "12px", mt: 0.5 }}>
                          {error}
                        </Typography>
                      )}
                    </Grid>
                  );
                }

                return (
                  <Grid size={{ xs: 12, md: gridWidth }} key={index}>
                    <Typography
                      sx={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", mb: 1 }}
                    >
                      {field.label}
                      {field.required && !viewMode && <span style={{ color: "#ef4444" }}> *</span>}
                    </Typography>
                    <TextField
                      name={field.name}
                      type={field.type || "text"}
                      variant="outlined"
                      fullWidth
                      size="medium"
                      required={field.required}
                      value={value}
                      onChange={handleChange}
                      disabled={isFieldDisabled}
                      placeholder={field.placeholder}
                      inputProps={field.inputProps}
                      error={!!error}
                      helperText={
                        error ||
                        (showNonEditableMessage ? "This field cannot be edited." : field.helperText || "")
                      }
                      autoComplete="off"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: viewMode ? "#f9fafb" : "#fff",
                          fontSize: "14px",
                          borderRadius: "8px",
                          ...(error && { "& fieldset": { borderColor: "#ef4444 !important" } }),
                        },
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ))}
      </DialogContent>
      <DialogActions
        sx={{
          padding: "16px 24px",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
        }}
      >
        {viewMode ? (
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              minWidth: "100px",
              height: "36px",
              textTransform: "none",
              backgroundColor: "#111827",
              color: "#fff",
              fontSize: "14px",
              fontWeight: 500,
              borderRadius: "8px",
              boxShadow: "none",
            }}
          >
            {cancelLabel}
          </Button>
        ) : (
          <>
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                minWidth: "100px",
                height: "36px",
                textTransform: "none",
                color: "#374151",
                borderColor: "#d1d5db",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "8px",
              }}
            >
              {cancelLabel}
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={isSubmitDisabled}
              sx={{
                minWidth: "100px",
                height: "36px",
                textTransform: "none",
                backgroundColor: "#111827",
                color: "#fff",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "8px",
                boxShadow: "none",
                "&:disabled": {
                  backgroundColor: "#d1d5db",
                  color: "#6b7280",
                  cursor: "not-allowed",
                },
              }}
            >
              {submitLabel}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;